import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import SideList from "../../../UI-component/SideList";
import ErrorAlert from "../../../UI-component/ErrorAlert";
import CustomerFormBox from "../../../UI-component/registryForms/CustomerFormBox";
import NextBtnForm from "../../../UI-component/NexBtnForm";
import stepSlice from "../../../context/StepsContext";
import SuccessfullPopup from "../../../UI-component/SuccessfullPopup";
import Loader from "../../../UI-component/Loader";

function General(props) {
  const dispatcher = useDispatch();
  const ctxApplicant = useSelector(state => state.stepSlice.data.richiedente);
  const ctxInvoice = useSelector(state => state.stepSlice.data.fatture?.[0]);
  const ctxFine = useSelector(state => state.stepSlice.data.multa);
  const ctxPractice = useSelector(state => state.stepSlice.data.practiceNumber);
  const isStopped = useSelector(state => state.stepSlice.data.stopped);
  const [loading, setLoading] = useState(false);
  const [applicant, setApplicant] = useState(/*props.info.data?.richiedente ??*/ ctxApplicant);
  const [error, setError] = useState(true);

  // console.log("ctxPractice", ctxPractice);
  const errorChecker = () => {
    if (!applicant || applicant?.length <= 0)
      setError(true);
    else
      setError(false);
  }

  useEffect(() => {
    errorChecker();
  }, [applicant])


  const update = (data) => {
    if (typeof data === "object") {
      if (data.removing) {
        setApplicant(undefined);
        dispatcher(stepSlice.actions.dynamicSave({ id: "Richiedente", data: { selected: false } }));
        return;
      }

      setApplicant(data.data);
      dispatcher(stepSlice.actions.dynamicSave({ id: "Richiedente", data: { ...data?.data?.[0], selected: true } }));
    }

    if (Array.isArray(data)) {
      setApplicant([]);
    }
  }

  const onNext = () => {
    dispatcher(stepSlice.actions.dynamicSave({ id: "Richiedente", data: { ...applicant[0], selected: true } }));

    props.next();
  }

  const save = async () => {
    const data = {
      richiedente: applicant?.length > 0 ? [{ ...applicant?.[0], selected: true }] : [],
      ...(ctxInvoice && {fatture: [ctxInvoice]}),
      multa: ctxFine,
      practice_number: ctxPractice
    }
    setLoading(true);
    console.log("data", data);


    await props.save(data);

    dispatcher(stepSlice.actions.dynamicSave({ id: "Richiedente", data: { ...applicant?.[0], selected: true } }));

    setLoading(false);
  }

  return (
    <div className="row">
      <SideList
        infoList={[
          { element: "Effettuato da", id: "#report-author" },
        ]} />

      <div className="col-12 col-lg-8 offset-lg-1">
        <div className="steppers-content" aria-live="polite">
          <div className="it-page-sections-container">

            {
              <ErrorAlert errors={[{ name: "Effettuato da", id: "#isee-info" }]} err={error || isStopped} />
            }

            <CustomerFormBox id="richiedente"
              cards={applicant?.length > 0 ? [applicant] : []}
              type={false}
              description="Informazione su di te"
              title="Effettuato da"
              service={props.info.code}
              update={update}
              prefData={props.info.data?.richiedente}
            />
          </div>
        </div>
        <Loader loading={loading} fixedPosition/>
        <NextBtnForm
          next={onNext}
          back={props.back}
          noSave={false}
          saveRequest={save}
          disabled={error || isStopped || loading} />

        {
          props.saved &&
          <SuccessfullPopup />
        }

        {
          props.fail &&
          <SuccessfullPopup isError={true} />
        }
      </div>
    </div>
  )
}


export default General;